export default {
  "yourAchievement": "Il tuo successo",
  "qualificationRecords": "Qualificazione e record",
  "recordedActivity": "Attività registrate",
  "exceptional": "Risultati eccezionali",
  "historicalPar": "Sono necessari istantanee di buco storiche o punteggi di buca salvati relativi al par; il corso di oggi par non viene utilizzato.",
  "matchResult": "Il risultato ha bisogno di un punteggio finale supportato e vincitore. Le sessioni informali salvate, i pensionati e le partite incompiute non stabiliscono una partita completa.",
  "title": "Risultati",
  "allCategories": "Tutti i gruppi",
  "informationLabel": "Informazioni sui record di successo",
  "intro": "Le tue pietre miliari dalla vita al club.",
  "all": "Tutti",
  "earned": "Guarnizione",
  "in_progress": "In corso",
  "history_incomplete": "La storia registrata è limitata",
  "source_unavailable": "Fonte temporaneamente non disponibile",
  "not_applicable": "Non applicabile",
  "category": "Categoria",
  "membership": "Iscrizione",
  "heritage": "Patrimonio della famiglia",
  "golf": "Golf",
  "racquet": "Sport di racchetta",
  "events": "Eventi Club",
  "spa": "Centro benessere",
  "academy": "Accademia",
  "loading": "Caricamento dei risultati...",
  "error": "I tuoi successi non potrebbero essere caricati.",
  "retry": "Riprova",
  "empty": "Nessun risultato corrisponde a questi filtri.",
  "close": "Chiudi",
  "details": "Dettagli del premio",
  "tiers": "Tutte le pietre miliari",
  "milestones": "Pietre miliari",
  "earnedDate": "Guadagnati su",
  "unknownDate": "La data esatta non è conosciuta.",
  "partial": "Il progresso riflette i record disponibili; la storia precedente può mancare.",
  "pending": "I suoi registri sono stati valutati.",
  "next": "Avanti",
  "future": "Futuro",
  "starting": "Non ti ho ancora guadagnato",
  "notEarned": "Non ancora guadagnato",
  "complete": "Tutte le pietre miliari guadagnate",
  "progressUnknown": "Progressi non disponibili",
  "source": "Fonte",
  "bookingPolicy": "Le prenotazioni programmate contano dal giorno seguente del calendario dopo la loro data prevista finale, nella zona temporale del club. Le prenotazioni cancellate e i no-show non contano.",
  "heritagePolicy": "I legami familiari esistenti collegano i periodi di appartenenza noti, compresi gli antenati attraverso i link genitori/bambini. I link non modificati utilizzano la relazione familiare esistente; i periodi di sovrapposizione contano una volta.",
  "automaticHelp": "Aggiornamento dei premi automaticamente. Date di appartenenza corrette, link di famiglia, prenotazioni e punteggi nei loro flussi di lavoro originali.",
  "history": "Risultati / Storia",
  "audit": "Correzione e storia dell'emissione",
  "reconcile": "Richiesta di riconciliazione",
  "saved": "La riconciliazione è in coda.",
  "staffError": "La richiesta non potrebbe essere completata.",
  "more": "Caricare più storia",
  "awards": {
    "membership_1": "Primo anniversario",
    "membership_5": "Cinque anni insieme",
    "membership_10": "Decennio di Membership",
    "membership_20": "Vent'anni insieme",
    "membership_25": "Quartiere Secolo",
    "membership_50": "Cinquanta anni insieme",
    "heritage_25": "Patrimonio · 25 anni",
    "heritage_50": "Patrimonio · 50 anni",
    "heritage_75": "Patrimonio · 75 anni",
    "heritage_100": "Patrimonio · 100 anni",
    "golf_rounds_1": "Primo Tee",
    "golf_rounds_10": "Trovare il tuo Swing",
    "golf_rounds_50": "Fairway Regolare",
    "golf_rounds_100": "Secolo di tondi",
    "golf_ace_1": "Buca in uno",
    "golf_under_par_1": "Sotto il par",
    "racquet_matches_1": "Primo Servo",
    "racquet_matches_10": "Nel Rally",
    "racquet_matches_50": "Corte di giustizia",
    "racquet_matches_100": "Secolo su Corte",
    "racquet_perfect_1": "Abbinamento perfetto",
    "events_1": "Parte del Club",
    "events_10": "Circolo sociale",
    "events_20": "Club Regolare",
    "events_50": "Incontro amichevole",
    "spa_1": "Un momento per te",
    "spa_10": "Benessere Rituale",
    "spa_25": "Tempo Beh Spettacolo",
    "academy_1": "Un nuovo capitolo",
    "academy_5": "Imparante per tutta la vita"
  },
  "qualifications": {
    "membership_1": "Raggiungere 1 anno di adesione continua.",
    "membership_5": "Raggiungere 5 anni di adesione continua.",
    "membership_10": "Raggiungere 10 anni di adesione continua.",
    "membership_20": "Raggiungere 20 anni di adesione continua.",
    "membership_25": "Raggiungere 25 anni di adesione continua.",
    "membership_50": "Raggiungere 50 anni di adesione continua.",
    "heritage_25": "Raggiungere 25 anni di appartenenza familiare, contando periodi sovrapposti una volta.",
    "heritage_50": "Raggiungere 50 anni di appartenenza familiare, contando periodi sovrapposti una volta.",
    "heritage_75": "Raggiungere 75 anni di appartenenza familiare, contando periodi sovrapposti una volta.",
    "heritage_100": "Raggiungere 100 anni di appartenenza familiare, contando periodi sovrapposti una volta.",
    "golf_rounds_1": "Completa 1 giro di golf registrato.",
    "golf_rounds_10": "Completa 10 giri di golf registrati.",
    "golf_rounds_50": "Completa 50 giri di golf registrati.",
    "golf_rounds_100": "Completa 100 giri di golf registrati.",
    "golf_ace_1": "Registrare un buca valido giocato in un colpo.",
    "golf_under_par_1": "Completa un giro lordo al di sotto del suo record storico par.",
    "racquet_matches_1": "Completo 1 racquet match.",
    "racquet_matches_10": "Completo 10 racchette partite.",
    "racquet_matches_50": "Completo di 50 racchette.",
    "racquet_matches_100": "Completa 100 partite di racchetta.",
    "racquet_perfect_1": "Vincere una partita di tennis o padel supportati completati senza conceding un gioco.",
    "events_1": "Avere 1 meritato prenotazione evento passato.",
    "events_10": "Avere 10 prenotazioni per eventi passati ammissibili.",
    "events_20": "Avere 20 prenotazioni per eventi passati ammissibili.",
    "events_50": "Avere 50 prenotazioni per eventi passati ammissibili.",
    "spa_1": "Avere 1 trattamento benessere passato eleggibile.",
    "spa_10": "Avere 10 trattamenti benessere precedenti ammissibili.",
    "spa_25": "Avere 25 trattamenti benessere precedenti ammissibili.",
    "academy_1": "Fine 1 programma Academy attraverso le iscrizioni programmate o il completamento online registrato.",
    "academy_5": "Finire 5 programmi Academy attraverso le iscrizioni programmate o il completamento on-line registrato."
  }
};
